/**
 * Message
 * The Message API
 *
 * The version of the OpenAPI document: master-8247d258-900790
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@nestjs/common';
import { HttpService } from '@nestjs/axios';
import { AxiosResponse } from 'axios';
import { Observable } from 'rxjs';
import { IncludedPersonBulkDto } from '../model/includedPersonBulkDto';
import { PaginatedRecipientListDto } from '../model/paginatedRecipientListDto';
import { RecipientListCreateDto } from '../model/recipientListCreateDto';
import { RecipientListDto } from '../model/recipientListDto';
import { RecipientListIncludedPersonDto } from '../model/recipientListIncludedPersonDto';
import { RecipientListUpdateDto } from '../model/recipientListUpdateDto';
import { Configuration } from '../configuration';
import { COLLECTION_FORMATS } from '../variables';


@Injectable()
export class RecipientListApi {

    protected basePath = 'http://.';
    public configuration = new Configuration();

    constructor(protected httpClient: HttpService, @Optional() configuration: Configuration) {
        this.configuration = configuration || this.configuration;
        this.basePath = configuration?.basePath || this.basePath;
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        return consumes.includes(form);
    }

    /**
     * 
     * 
     * @param id 
     * @param includedPersonBulkDto 
     */
    public bulkRecipientListIncludedPeople(id: string, includedPersonBulkDto: IncludedPersonBulkDto, ): Observable<AxiosResponse<Array<RecipientListIncludedPersonDto>>>;
    public bulkRecipientListIncludedPeople(id: string, includedPersonBulkDto: IncludedPersonBulkDto, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling bulkRecipientListIncludedPeople.');
        }

        if (includedPersonBulkDto === null || includedPersonBulkDto === undefined) {
            throw new Error('Required parameter includedPersonBulkDto was null or undefined when calling bulkRecipientListIncludedPeople.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.post<Array<RecipientListIncludedPersonDto>>(`${this.basePath}/recipients-list/${encodeURIComponent(String(id))}/person/bulk`,
            includedPersonBulkDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param recipientListCreateDto 
     */
    public createRecipientList(recipientListCreateDto: RecipientListCreateDto, ): Observable<AxiosResponse<RecipientListDto>>;
    public createRecipientList(recipientListCreateDto: RecipientListCreateDto, ): Observable<any> {

        if (recipientListCreateDto === null || recipientListCreateDto === undefined) {
            throw new Error('Required parameter recipientListCreateDto was null or undefined when calling createRecipientList.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.post<RecipientListDto>(`${this.basePath}/recipient-list`,
            recipientListCreateDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public deleteRecipientList(id: string, ): Observable<AxiosResponse<RecipientListDto>>;
    public deleteRecipientList(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteRecipientList.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.delete<RecipientListDto>(`${this.basePath}/recipients-list/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     * @param person 
     */
    public deleteRecipientListIncludedPerson(id: string, person: string, ): Observable<AxiosResponse<RecipientListIncludedPersonDto>>;
    public deleteRecipientListIncludedPerson(id: string, person: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteRecipientListIncludedPerson.');
        }

        if (person === null || person === undefined) {
            throw new Error('Required parameter person was null or undefined when calling deleteRecipientListIncludedPerson.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.delete<RecipientListIncludedPersonDto>(`${this.basePath}/recipients-list/${encodeURIComponent(String(id))}/person/${encodeURIComponent(String(person))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public getRecipientList(id: string, ): Observable<AxiosResponse<RecipientListDto>>;
    public getRecipientList(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getRecipientList.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<RecipientListDto>(`${this.basePath}/recipients-list/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     */
    public getRecipientListIncludedPeople(id: string, ): Observable<AxiosResponse<Array<RecipientListIncludedPersonDto>>>;
    public getRecipientListIncludedPeople(id: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getRecipientListIncludedPeople.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<Array<RecipientListIncludedPersonDto>>(`${this.basePath}/recipients-list/${encodeURIComponent(String(id))}/person`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     * @param person 
     */
    public getRecipientListIncludedPerson(id: string, person: string, ): Observable<AxiosResponse<RecipientListIncludedPersonDto>>;
    public getRecipientListIncludedPerson(id: string, person: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getRecipientListIncludedPerson.');
        }

        if (person === null || person === undefined) {
            throw new Error('Required parameter person was null or undefined when calling getRecipientListIncludedPerson.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<RecipientListIncludedPersonDto>(`${this.basePath}/recipients-list/${encodeURIComponent(String(id))}/person/${encodeURIComponent(String(person))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param limit 
     * @param offset 
     * @param search Search by title, description or id
     * @param organization Filter by organization
     * @param sort Sort by one or more properties. Use \&#39;+\&#39; for ascending and \&#39;-\&#39; for descending.
     */
    public getRecipientLists(limit?: number, offset?: number, search?: string, organization?: Array<string>, sort?: Array<'+title' | '-title' | '+description' | '-description' | '+numOfIncludedPeople' | '-numOfIncludedPeople' | '+updatedAt' | '-updatedAt'>, ): Observable<AxiosResponse<PaginatedRecipientListDto>>;
    public getRecipientLists(limit?: number, offset?: number, search?: string, organization?: Array<string>, sort?: Array<'+title' | '-title' | '+description' | '-description' | '+numOfIncludedPeople' | '-numOfIncludedPeople' | '+updatedAt' | '-updatedAt'>, ): Observable<any> {






        let queryParameters = new URLSearchParams();
        if (limit !== undefined && limit !== null) {
            queryParameters.append('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters.append('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters.append('search', <any>search);
        }
        if (organization) {
            organization.forEach((element) => {
                queryParameters.append('organization', <any>element);
            })
        }
        if (sort) {
            queryParameters.append('sort', sort.join(COLLECTION_FORMATS['csv']));
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<PaginatedRecipientListDto>(`${this.basePath}/recipients-list`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     * @param person 
     */
    public includeRecipientListPerson(id: string, person: string, ): Observable<AxiosResponse<RecipientListIncludedPersonDto>>;
    public includeRecipientListPerson(id: string, person: string, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling includeRecipientListPerson.');
        }

        if (person === null || person === undefined) {
            throw new Error('Required parameter person was null or undefined when calling includeRecipientListPerson.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.post<RecipientListIncludedPersonDto>(`${this.basePath}/recipients-list/${encodeURIComponent(String(id))}/person/${encodeURIComponent(String(person))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param id 
     * @param recipientListUpdateDto 
     */
    public updateRecipientList(id: string, recipientListUpdateDto: RecipientListUpdateDto, ): Observable<AxiosResponse<RecipientListDto>>;
    public updateRecipientList(id: string, recipientListUpdateDto: RecipientListUpdateDto, ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateRecipientList.');
        }

        if (recipientListUpdateDto === null || recipientListUpdateDto === undefined) {
            throw new Error('Required parameter recipientListUpdateDto was null or undefined when calling updateRecipientList.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.patch<RecipientListDto>(`${this.basePath}/recipient-list/${encodeURIComponent(String(id))}`,
            recipientListUpdateDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
}
